import { Switch } from '@thanx/uikit/switch'
import Help from 'components/Help'
import useFlag from 'hooks/useFlag'
import { Fields as RedeemTemplate } from 'models/RedeemTemplate'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { getHelp } from 'scenes/RedeemManager/Builder/ConfigurationStep/helpers'
import Restrictions from 'scenes/RedeemManager/Builder/ConfigurationStep/Restrictions'
import {
  generateTypeItem,
  getMinMaxVisibility,
} from 'scenes/RedeemManager/helpers'
import CustomerSupportCard from './CustomerSupportCard'
import InstoreRedemptionCard from './InstoreRedemptionCard'
import MaximumDiscountCard from './MaximumDiscountCard'
import MinimumSpendCard from './MinimumSpendCard'
import MultipleInstoreRedemptionCard from './MultipleInstoreRedemptionCard'
import MultiUseCard from './MultiUseCard'
import OnlineRedemptionCard from './OnlineRedemptionCard'
import RewardDetailsCard from './RewardDetailsCard'

type PropsT = {
  template: RedeemTemplate
}

const ConfigurationTab: React.FC<PropsT> = ({ template }) => {
  const typeItem = generateTypeItem(template)
  const freeModifierRewardsEnabled = useFlag('mx-free-modifier-rewards', false)
  const templateMinMaxEnabled = useFlag('mx-template-min-max', false)
  const helpArticles = getHelp(typeItem?.key, freeModifierRewardsEnabled)

  const isExperience = template.type.includes('experience')
  const isDeliveryDiscount = typeItem?.key === 'delivery_discount'
  const isBonusPoints = typeItem?.key === 'bonus_points'
  // $-off templates have no `maximum` field.
  const isDollarOff = template.type.endsWith('/amount')
  const { showMinimumSpend, showMaximumDiscount } = getMinMaxVisibility({
    templateMinMaxEnabled,
    isDeliveryDiscount,
    isBonusPoints,
    isExperience,
    isDollarOff,
  })

  return (
    <>
      <RewardDetailsCard template={template} typeItem={typeItem} />
      <Switch condition={!isBonusPoints}>
        <OnlineRedemptionCard template={template} />
        <Switch
          // Fallback to showing only a single card if it's an experience reward
          condition={!isExperience}
          fallback={<InstoreRedemptionCard template={template} />}
        >
          <MultipleInstoreRedemptionCard template={template} />
        </Switch>
      </Switch>
      <Switch condition={showMinimumSpend}>
        <MinimumSpendCard template={template} />
      </Switch>
      <Switch condition={showMaximumDiscount}>
        <MaximumDiscountCard template={template} />
      </Switch>
      <MultiUseCard template={template} />
      <CustomerSupportCard template={template} />
      <Restrictions />
      <Help
        title={I18n.t('redeem_manager.builder.steps.configuration.help.title')}
        articles={helpArticles}
      />
    </>
  )
}

export default ConfigurationTab
